// extracted by mini-css-extract-plugin
export default {"payroll-sum-emp-header":"PayrollSummEmpReport_payroll-sum-emp-header__BSC44","divider":"PayrollSummEmpReport_divider__esOlB"};